export const SUPPORT_GET_MESSAGE_SUCCESS = 'SUPPORT/GET_MESSAGE_SUCCESS'
export const SUPPORT_GET_MESSAGE_FAILURE = 'SUPPORT/GET_MESSAGE_FAILURE'

export const SUPPORT_SEND_MESSAGE_SUCCESS = 'SUPPORT/SEND_MESSAGE_SUCCESS'
export const SUPPORT_SEND_MESSAGE_FAILURE = 'SUPPORT/SEND_MESSAGE_FAILURE'